<template>
    <div>
        <video
            id="myVideo"
            class="video-js vjs-default-skin"
            playsinline
        ></video>
        <!-- <a href="JavaScript:void(0);" @click="onClick()">Change Device</a> -->
    </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import 'videojs-record/dist/css/videojs.record.css'

import 'webrtc-adapter'
import RecordRTC from 'recordrtc'

import videojs from 'video.js'
// eslint-disable-next-line
import Record from 'videojs-record/dist/videojs.record.js'

export default {
    data() {
        return {
            player: '',
            options: {
                controls: true,
                autoplay: false,
                fluid: true,
                loop: false,
                width: 500,
                height: 281,
                facingMode: 'environment',
                debug: true,
                controlBar: {
                    volumePanel: true,
                },
                plugins: {
                    // configure videojs-record plugin
                    record: {
                        audio: false,
                        video: {
                            deviceId: {
                                exact: this.videoSelected,
                            },
                        },
                        debug: true,
                        maxLength: 10,
                        // deviceId: { exact: deviceId },
                        videoRecorderType: 'WhammyRecorder',
                        videoMimeType: 'video/mp4',
                    },
                },
            },
            videoSelected: 0,
            videoId: [],
        }
    }, // End of Component > methods

    mounted() {
        /* eslint-disable no-console */
        this.player = videojs('#myVideo', this.options, () => {
            // print version information at startup
            var msg =
                'Using video.js ' +
                videojs.VERSION +
                ' with videojs-record ' +
                videojs.getPluginVersion('record') +
                ' and recordrtc ' +
                RecordRTC.version
            videojs.log(msg)
        })

        this.player.record().getDevice()

        this.player.record().enumerateDevices()

        this.player.record().setVideoInput(this.deviceId)

        console.log(this.player.record().devices)
        var $this = this
        this.player.on('enumerateReady', function () {
            console.log($this.player.record().devices)
            var devices = $this.player.record().devices
            console.log(devices[2])
            devices.forEach(function (device) {
                if (device.kind == 'videoinput') {
                    $this.videoId.push(device)
                }
            })
            console.log($this.videoId)
        })

        // error handling
        this.player.on('enumerateError', function () {
            console.log('enumerate error:', this.player.enumerateErrorCode)
        })

        // device is ready
        this.player.on('deviceReady', () => {
            console.log('device is ready!')
        })

        // user clicked the record button and started recording
        this.player.on('startRecord', () => {
            this.$emit('recordingStarted')
            console.log('recordingStarted')
        })

        this.player.on('stopRecord', () => {
            this.$emit('recordingStarted')
            console.log('stop')
        })

        // user completed recording and stream is available
        this.player.on('finishRecord', () => {
            // the blob object contains the recorded data that
            // can be downloaded by the user, stored on server etc.
            this.$emit('recordingEnded', this.player)
        })

        // error handling
        this.player.on('error', (element, error) => {
            console.warn(error)
        })

        this.player.on('deviceError', () => {
            console.error('device error:', this.player.deviceErrorCode)
        })
        this.onLoad()
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onClick() {
            var length = this.videoId.length - 1
            if (this.videoSelected >= length) {
                this.videoSelected = 0
                this.options.plugins.record.video.deviceId.exact =
                    this.videoId[this.videoSelected].deviceId
            } else {
                this.videoSelected++
                this.options.plugins.record.video.deviceId.exact =
                    this.videoId[this.videoSelected].deviceId
            }
        },
        onLoad() {
            var $this = this
            setTimeout(function () {
                $this.options.plugins.record.video.deviceId.exact =
                    $this.videoId[0].deviceId
            }, 500)
        },
    },
}
</script>
